import { PageLoader } from "@features/common/ui/PageLoader";
import { Failure } from "@features/Failure";
import { useKeycloak } from "@react-keycloak/web";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ element }) => {
  const { keycloak, initialized } = useKeycloak();

  const isAuthenticated = keycloak.authenticated;
  const location = useLocation();

  const [showFailure, setShowFailure] = useState(false);

  useEffect(() => {
    if (!initialized) {
      const timer = setTimeout(() => {
        setShowFailure(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [initialized]);

  if (!initialized && !showFailure) {
    return <PageLoader />;
  }

  if (!initialized && showFailure) {
    return (
      <Failure headerMsg="" message="Cannot connect to authentication server" />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return element;
};
PrivateRoute.propTypes = {
  element: PropTypes.element.isRequired,
};
export default PrivateRoute;
